<template>
  <!--v-container fluid v-resize="onResize"-->
  <v-container>
    <!-- About us -->
    <v-layout align-center justify-center pb-3 v-show="media.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; Now available
          </v-card-title>
          <v-card-text>
            <div style="position: relative;padding-bottom: 56.25%;height: 0">
              <iframe style="position: absolute;top: 0;left: 0;width: 100%;height: 100%"
                      src="https://www.youtube.com/embed/y6uuKI5B6T8?controls=0&modestbranding=1&rel=0" frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step 1 -->
    <v-layout align-center justify-center pb-3 id="step-1" v-show="s1.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; I want to be seen for
          </v-card-title>
          <v-layout wrap text-xl-center text-lg-center text-md-center text-sm-center text-xs-center>
            <v-flex v-for="profile in hiddenOptions" :key="profile.id" xl6 lg6 md6 sm6 xs12>
              <v-btn class="select-button"
                     v-bind:class="{primary: isProfileActive(profile.id), yellow: isProfileCallToAction(profile)}"
                     v-on:click="selectProfile(profile)">
                <v-icon left>{{ profile.icon }}</v-icon>
                {{ profile.name }}
                <br v-show="profile.name_line_2">
                {{ profile.name_line_2 }}
              </v-btn>
              <p>{{ profile.description }}</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step 1-1 -->
    <v-layout align-center justify-center pb-3 id="step-1-1" v-show="s1_1.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; I want to be seen for
          </v-card-title>
          <v-layout wrap text-xl-center text-lg-center text-md-center text-sm-center text-xs-center class="pb-2">
            <v-flex v-for="subProfile in profileInfo.sub_profiles" :key="subProfile.id" xl6 lg6 md6 sm6 xs12>
              <v-btn class="select-button" v-bind:class="{primary: isSubProfileActive(subProfile.id)}"
                     v-on:click="selectSubProfile(subProfile)">
                <v-icon left>fa-chevron-right</v-icon>
                {{ subProfile.name }}
              </v-btn>
              <p>{{ subProfile.description }}</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step 2 -->
    <v-layout align-center justify-center pb-3 id="step-2" v-show="s2.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; Have you seen us before
          </v-card-title>
          <v-layout wrap text-xl-center text-lg-center text-md-center text-sm-center text-xs-center class="pb-2">
            <!-- New -->
            <v-flex xl6 lg6 md6 sm6 xs12 v-show="isNewPatientActive()">
              <v-btn class="select-button" v-bind:class="{primary: isPatientStatusActive('new')}"
                     v-on:click="selectPatientStatus('new')">
                <v-icon left>fa-child</v-icon>
                New Patient
              </v-btn>
            </v-flex>
            <!-- Existing -->
            <v-flex xl6 lg6 md6 sm6 xs12>
              <v-btn class="select-button" v-bind:class="{primary: isPatientStatusActive('existing')}"
                     v-on:click="selectPatientStatus('existing')">
                <v-icon left>fa-male</v-icon>
                Existing Patient
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step - Region -->
    <v-layout align-center justify-center pb-3 id="step-region" v-show="sRegion.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; I want to be seen in
          </v-card-title>
          <v-layout wrap text-xl-center text-lg-center text-md-center text-sm-center text-xs-center class="pb-2">

            <!-- Regions -->
            <v-flex v-for="region in hiddenRegions" :key="regions.id" xl6 lg6 md6 sm6 xs12>
              <v-btn class="select-button" v-bind:class="{primary: isRegionActive(region.id)}"
                     v-on:click="selectRegion(region.id)">
                <v-icon left small>fa-city</v-icon>
                {{ region.name }}
              </v-btn>
            </v-flex>

          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step 3 -->
    <v-layout row align-center justify-center pb-3 id="step-3" v-show="s3.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0" v-if="COMPANY_NAME === 'Total Behavioral Health'">
            <span class="headline font-weight-bold"></span>&nbsp; I want to be seen by
          </v-card-title>
          <v-card-title class="pb-0" v-if="COMPANY_NAME !== 'Total Behavioral Health'">
            <span class="headline font-weight-bold"></span>&nbsp; I want to be seen at
          </v-card-title>
          <v-card-text class="pt-0">
            <!-- Loading -->
            <div v-show="s3.loading"
                 class="text-xl-center text-lg-center text-md-center text-sm-center text-xs-center">
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </div>
            <!-- Something went wrong -->
            <div v-show="s3.error"
                 class="text-xl-center text-lg-center text-md-center text-sm-center text-xs-center red--text">
              <p class="font-weight-bold">Something went wrong...</p>
              <v-btn color="warning" v-on:click="getAvailabilities()">
                <v-icon left>fa-redo</v-icon>
                Retry
              </v-btn>
            </div>
            <!-- Availabilities -->
            <div v-show="s3.entities && !s3.loading && !s3.error">
              <v-layout>
                <v-flex xl6 lg6 md6 sm6 xs6>
                  <v-btn flat color="primary" v-show="s3.previous.length > 0" v-on:click="getPrevious()">
                    <v-icon>fa-arrow-left</v-icon>
                    &nbsp;Previous
                  </v-btn>
                </v-flex>
                <v-flex xl6 lg6 md6 sm6 xs6 text-xl-right text-lg-right text-md-right text-sm-right text-xs-right>
                  <v-btn flat color="primary" v-on:click="getNext()">
                    Next&nbsp;
                    <v-icon>fa-arrow-right</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <!-- Offices -->
              <div v-for="entity in s3.entities" :key="entity.office_id">
                <v-divider></v-divider>
                <v-layout>
                  <!-- Office header -->
                  <v-flex xl3 lg md3 sm2 xs4 mr-2 mt-3>
                    <div v-show="entity.doctor_url"><img :src="entity.doctor_url" height="80" width="80"></div>
                    <div class="font-weight-bold">{{ entity.name }}</div>
                    <div>{{ entity.description }}</div>
                    <div v-show="entity.distance">{{ entity.distance }} miles</div>
                    <div v-show="entity.wordpress_link"><a target="_blank" rel="noopener noreferrer" :href="entity.wordpress_link">Learn More</a></div>
                  </v-flex>
                  <!-- Times -->
                  <v-flex xl1 lg1 md1 sm2 xs2 class="date-column" v-for="date in entity.dates" :key="date.date"
                          v-if="entity.message === null" text-xl-center text-lg-center text-md-center
                          text-sm-center>
                    <div class="font-weight-bold">{{ getPrettyDate(date.date) }}</div>
                    <div class="time-outer" v-for="time in date.times" :key="time">
                      <!-- Available Time -->
                      <span class="time-item primary clickable" style="text-align: center"
                            v-show="!isTimeSelected(entity.office_id, entity.doctor_id, date.date, time)"
                            v-on:click="selectTime(entity, date.date, time)">{{ getPrettyTime(time) }}</span>
                      <!-- Selected Time -->
                      <span class="time-item-selected success font-weight-bold " style="text-align: center"
                            v-show="isTimeSelected(entity.office_id, entity.doctor_id, date.date, time)">{{
                          getPrettyTime(time)
                        }}</span>
                    </div>
                    <div class="time-outer" v-for="padding in (paddingCount(entity.dates) - date.times.length)"
                         :key="padding">
                      <!-- Padding Time -->
                      <span class="time-item time-item-padding">&nbsp;</span>
                    </div>
                  </v-flex>
                  <!-- Office has message -->
                  <v-flex xl7 lg7 md5 sm5 xs5 class="date-column" v-if="entity.message !== null"
                          text-xl-center text-lg-center text-md-center text-sm-center>
                    <div v-if="entity.message === 'program-not-available'">
                      Appointment type is not offered at this time.
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Step 4 -->
    <v-layout align-center justify-center pb-3 id="step-4" v-show="s4.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-title class="pb-0">
            <span class="headline font-weight-bold"></span>&nbsp; Tell us about yourself
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <!-- Appointment Form -->
              <v-flex xl6 lg6 md6 sm6 xs12>
                <v-form>
                  <v-text-field v-model.trim="appointment.patient.name" label="Full Name"
                                v-validate="'required|nameValid|min:2'"
                                data-vv-name="Full Name" :error-messages="errors.collect('Full Name')"
                                prepend-icon="fa-user-circle" name="name" required></v-text-field>
                  <v-menu ref="dobMenu" :close-on-content-click="false" v-model="dobMenu"
                          :nudge-right="40" lazy
                          transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" v-model="dateOfBirthFormatted" label="Date Of Birth"
                                  prepend-icon="fa-calendar-alt"
                                  @blur="dateOfBirthFormatted = formatDate(dateOfBirthFormatted); appointment.patient.date_of_birth = parseDate(dateOfBirthFormatted)"
                                  v-validate="'required|dobValid|dobRange'" data-vv-name="Date of Birth"
                                  :error-messages="errors.collect('Date of Birth')" name="date_of_birth"
                                  autocomplete="off"
                                  required @change="saveDob"></v-text-field>
                    <v-date-picker ref="picker" @input="dobMenu = false" v-model="appointment.patient.date_of_birth"
                                   :max="getMaxDob()"
                                   :min="getMinDob()" @change="saveDob"></v-date-picker>
                  </v-menu>
                  <v-text-field v-model.trim="appointment.patient.cell_phone" label="Phone" required
                                v-validate="'required|phone'"
                                data-vv-name="Phone" prepend-icon="fa-phone"
                                :error-messages="errors.collect('Phone')" name="phone"></v-text-field>
                  <v-text-field v-model.trim="appointment.patient.email"
                                v-validate="'required|email'"
                                label="E-mail"
                                required
                                prepend-icon="fa-envelope" :error-messages="errors.collect('E-mail')"
                                data-vv-name="E-mail" name="email"></v-text-field>
                  <v-select v-model="appointment.payment_method" :items="paymentMethods" item-text="value"
                            item-value="key" label="Payment Method" prepend-icon="fa-dollar-sign"
                            v-validate="'required'"
                            data-vv-name="Payment Method" :error-messages="errors.collect('Payment Method')"
                            v-if="appointment.patient.status === 'new'" name="payment-method"></v-select>
                  <v-text-field v-model.trim="appointment.notes" label="Notes for your Provider"
                                prepend-icon="fa-notes-medical" v-validate.continues="'notes'"
                                data-vv-name="Notes for your Provider"
                                :error-messages="errors.collect('Notes for your Provider')" name="notes"></v-text-field>
                </v-form>
              </v-flex>
              <!-- Appointment Summary -->
              <v-flex xl6 lg6 md6 sm6 xs12 text-xl-center text-lg-center text-md-center text-sm-center text-xs-center>
                <!-- Appointment Time -->
                <div class="font-weight-bold" >
                  <v-icon small>fa-clock</v-icon>
                  Appointment Time
                </div>
                <div class="pb-3">{{ getPrettyDate(appointment.date) }} - {{ getPrettyTime(appointment.time) }}</div>
                <!-- Clinic Address -->
                <div v-show="summaryInfo.address" class="font-weight-bold">
                  <v-icon small>fa-map-marker</v-icon>
                  Clinic Address
                </div>
                <div v-if="summaryInfo.doctorName && !summaryInfo.address && profileInfo.telemed !== true" class="font-weight-bold">
                  <v-icon small>fa-user</v-icon>
                  Provider Name
                  <div class="pb-3 font-weight-regular">
                    {{ summaryInfo.doctorName }}
                  </div>
                </div>
                <div v-if="summaryInfo.address">
                  {{ summaryInfo.address }}
                </div>
                <div class="pb-3" v-show="!profileInfo.telemed">{{ summaryInfo.city }}, {{ summaryInfo.state }}
                  {{ summaryInfo.zip }}
                </div>
                <!-- Optional Profile Message -->
                <div class="font-weight-bold deep-orange--text" v-show="profileInfo.message">
                  <v-icon small color="deep-orange">fa-exclamation-triangle</v-icon>
                  Heads Up
                </div>
                <div class="pb-3 deep-orange--text font-weight-bold" style="width: 80%; margin: auto"
                     v-show="profileInfo.message">
                  {{ profileInfo.message }}
                </div>
                <!-- Book Button -->
                <div class="pb-3">
                  <v-btn class="book-button v-btn--small theme--dark" v-on:click="bookAppointment()"
                         :loading="s4.booking"
                         :disabled="s4.booking">
                    <v-icon left>fa-paper-plane</v-icon>
                    Book Appointment
                  </v-btn>
                </div>
                <div class="font-weight-bold" v-show="summaryInfo.phone">
                  <v-icon small>fa-phone</v-icon>
                  Phone
                </div>
                <div class="pb-3"><a :href="'tel:' + summaryInfo.phone">{{ summaryInfo.phone }}</a></div>
                <!-- Clinic Map -->
                <a :href="summaryInfo.google_place_url" target="_blank" v-show="!profileInfo.telemed">
                  <img :src="summaryInfo.map_url" height="200" width="200">
                </a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Complete -->
    <v-layout align-center justify-center pb-3 v-show="completed.show" id="completed">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-text class="text-xl-center text-lg-center text-md-center text-sm-center text-xs-center">
            <div v-if="showDirectLink() === false">
              <p>Thank you for booking your appointment with {{ COMPANY_NAME }}.</p>
              <!-- Appointment Summary -->
              <div class="font-weight-bold">
                <v-icon small>fa-clock</v-icon>
                Appointment Time
              </div>
              <div class="pb-3">{{ getPrettyDate(appointment.date) }} - {{ getPrettyTime(appointment.time) }}</div>
              <div class="font-weight-bold deep-orange--text" v-show="profileInfo.message">
                <v-icon small color="deep-orange">fa-exclamation-triangle</v-icon>
                Heads Up
              </div>
              <div class="pb-3 deep-orange--text font-weight-bold" style="width: 60%; margin: auto"
                   v-show="profileInfo.message">
                {{ profileInfo.message }}
              </div>
              <!-- Clinic Address -->
              <div v-show="summaryInfo.address" class="font-weight-bold">
                <v-icon small>fa-map-marker</v-icon>
                Clinic Address
              </div>
              <div>{{ summaryInfo.address }}</div>
              <div class="pb-3" v-show="!profileInfo.telemed">{{ summaryInfo.city }}, {{ summaryInfo.state }}
                {{ summaryInfo.zip }}
              </div>
              <div v-if="summaryInfo.doctorName && !summaryInfo.address && profileInfo.telemed !== true" class="font-weight-bold">
                <v-icon small>fa-user</v-icon>
                Provider Name
                <div class="pb-3 font-weight-regular">
                  {{ summaryInfo.doctorName }}
                </div>
              </div>
              <div class="font-weight-bold" v-show="summaryInfo.phone">
                <v-icon small>fa-phone</v-icon>
                Phone
              </div>
              <div class="pb-3"><a :href="'tel:' + summaryInfo.phone">{{ summaryInfo.phone }}</a></div>
              <!-- Clinic Map -->
              <a :href="summaryInfo.google_place_url" target="_blank" v-show="!profileInfo.telemed">
                <img :src="summaryInfo.map_url" height="200" width="200">
              </a>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Invalid Link -->
    <v-layout align-center justify-center pb-3 id="step-invalid" v-show="invalid.show">
      <v-flex xl5 lg7 md9 sm11 xs12>
        <v-card>
          <v-card-text class="text-xl-center text-lg-center text-md-center text-sm-center text-xs-center">
            <div class="pt-3 red--text font-weight-black title"
                 style="width: 60%; margin: auto">
              <v-icon color="red">fa-times</v-icon>&nbsp; The link you have is invalid.
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Error Snackbar -->
    <v-snackbar v-model="errorSnackbar.visible" buttom color="error" :timeout="snackTimeout" auto-height="true">
      {{ errorSnackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import _ from 'underscore'
  import moment from 'moment'
  import PhoneNumber from 'awesome-phonenumber'
  import human from 'humanparser'

  export default {
    data: () => {
      return {
        // Injected as part of webpack build
        COMPANY_LOGO: process.env.COMPANY_LOGO,
        COMPANY_NAME: process.env.COMPANY_NAME,
        COMPANY_DOCTOR: process.env.COMPANY_DOCTOR,
        COMPANY_COLOR_PRIMARY: process.env.COMPANY_COLOR_PRIMARY,
        COMPANY_COLOR_SECONDARY: process.env.COMPANY_COLOR_SECONDARY,
        DATE_OF_BIRTH: process.env.DATE_OF_BIRTH,
        profiles: process.env.APPOINTMENT_PROFILES,
        regions: process.env.REGIONS,
        after_hours_region_id: null,
        snackTimeout: 3000,
        // Meta page data
        media: {
          show: false
        },
        s1: {
          show: true
        },
        s1_1: {
          show: false
        },
        s2: {
          show: false
        },
        sRegion: {
          show: false
        },
        s3: {
          show: false,
          loading: false,
          error: false,
          dateCount: 3,
          previous: [],
          current: moment().isDST() ? moment().utc().utcOffset('-05:00').format('YYYY-MM-DD') : moment().utc().utcOffset('-06:00').format('YYYY-MM-DD'),
          next: null,
          entities: null
        },
        s4: {
          show: false,
          booking: false
        },
        completed: {
          show: false
        },
        invalid: {
          show: false
        },
        availabilities: null,
        dobMenu: false,
        errorSnackbar: {
          visible: false,
          message: ''
        },
        paymentMethods: [
          {
            key: 'insurance',
            value: 'Insurance'
          },
          {
            key: 'cash',
            value: 'Self Pay'
          }
        ],
        summaryInfo: {
          address: null,
          doctorName: null,
          city: null,
          state: null,
          zip: null,
          phone: null,
          google_place_url: null,
          map_url: null
        },
        profileInfo: {
          name: null,
          message: null,
          notes_required: false,
          existing_only: false,
          telemed: false,
          sub_profiles: null,
          after_hours: false,
          after_hours_url: null
        },
        // Appointment data
        appointment: {
          id: null,
          doctor_id: null,
          region: null,
          source: null,
          referrer: null,
          latitude: null,
          longitude: null,
          query: null,
          href: null,
          scheduled_time_override: false,
          after_hours: false,
          patient: {
            id: null,
            status: null,
            name: null,
            date_of_birth: null,
            phone: null,
            email: null
          },
          profile: null,
          sub_profile: null,
          entity: null,
          doctor: null,
          date: null,
          time: null,
          payment_method: null,
          notes: '',
          job_id: null
        },
        dateOfBirthFormatted: null,
        dateOfBirthRules: [
          v => !!v || 'Required',
          v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Expected date format MM/DD/YYYY'
        ]
      }
    },
    watch: {
      dobMenu (val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
    },
    async beforeMount () {
      // Light theme
      this.$vuetify.theme.primary = process.env.COMPANY_COLOR_PRIMARY
      this.$vuetify.theme.success = process.env.COMPANY_COLOR_SECONDARY

      // Store url params
      this.appointment.query = this.$route.query

      // Store href
      this.appointment.href = window.location.href

      // Show media
      if (this.$route.query.media && typeof this.$route.query.media === 'string') {
        this.media.show = true
      }

      // Store source
      if (this.$route.query.s && typeof this.$route.query.s === 'string') {
        this.appointment.source = this.$route.query.s
      }

      // Store patient id
      if (this.$route.query.p && typeof this.$route.query.p === 'string') {
        this.s1.show = false
        this.appointment.patient.id = this.$route.query.p
      }

      // Store referrer
      this.appointment.referrer = document.referrer

      // Calculate after_hours region id
      this.after_hours_region_id = this.afterHoursRegionId

      // Custom note validation
      this.$validator.extend('nameValid', {
        getMessage: field => {
          return `The ${field} field must have a first and last name`
        },
        validate: value => {
          const parsedName = human.parseName(value)
          if (parsedName.firstName.length < 2 || parsedName.lastName.length < 2) {
            return false
          }
          return true
        }
      })

      // Custom email validation
      this.$validator.extend('email', {
        getMessage: field => {
          return `The ${field} field must be a valid email`
        },
        validate: value => {
          return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(value)
        }
      })

      this.$validator.extend('phone', {
        getMessage: field => {
          return `The ${field} field must be a valid phone number.`
        },
        validate: value => {
          const phone = PhoneNumber(value, 'US')
          if (phone.isValid() === false || phone.isPossible() === false) {
            return false
          }
          return true
        }
      })

      this.$validator.extend('dobValid', {
        getMessage: field => {
          return `The ${field} field must be a valid date (MM/DD/YYYY)`
        },
        validate: value => {
          const dobMoment = moment(value, 'MM/DD/YYYY', true)
          if (dobMoment.isValid() === true) {
            return true
          }
          return false
        }
      })

      this.$validator.extend('dobRange', {
        getMessage: (field) => {
          return `Outside of age range: Expected ${this.DATE_OF_BIRTH.min} - ${this.DATE_OF_BIRTH.max} years`
        },
        validate: value => {
          const dobMoment = moment(value, 'MM/DD/YYYY', true)
          if (dobMoment.isSameOrBefore(this.getMaxDob()) && dobMoment.isSameOrAfter(this.getMinDob())) {
            return true
          }
          return false
        }
      })

      // Custom note validation
      this.$validator.extend('notes', {
        getMessage: field => {
          return `The ${field} field is required`
        },
        validate: value => {
          if (this.profileInfo.notes_required === true) {
            const cleanedNote = value.replace(/[^A-Z]/ig, '')
            if (cleanedNote.length < 2) {
              return false
            }
          }
          return true
        }
      })

      // Custom consent validation
      this.$validator.extend('consent', {
        getMessage: field => {
          return `The ${field} field is required`
        },
        validate: value => {
          return value === true
        }
      })
    },
    async mounted () {
      // Set date count on page load
      this.setDateCount()

      // Get pre-load parameters
      const regexp = /(\?|&)([^=]+)=([^&#]+)/g
      if (this.appointment.href !== undefined) {
        const elimPostQuery = this.appointment.href.substring(0, this.appointment.href.indexOf('#/'))
        const preParams = [...elimPostQuery.matchAll(regexp)]
        for (let i = 0; i < preParams.length; i++) {
          const key = preParams[i][2]
          const value = preParams[i][3]
          this.$route.query[key] = value
        }
      }

      // Get geolocation
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.appointment.latitude = position.coords.latitude
          this.appointment.longitude = position.coords.longitude
        })
      }

      // Set profile
      if (this.$route.query.profile && typeof this.$route.query.profile === 'string') {
        let subHandleFlag = false
        let checkProfile
        for (let i = 0; i < this.profiles.length; i++) {
          if (this.profiles[i].id === parseInt(this.$route.query.profile)) {
            checkProfile = this.profiles[i]
            //  If URL profile is hidden, show it
            if (this.profiles[i].hidden === true) {
              this.profiles[i].hidden = false
            }
          }
        }
        if (checkProfile !== undefined) {
          this.s2.show = true
          if (checkProfile.sub_profiles !== undefined) {
            this.appointment.profile = undefined
            await this.selectProfile(checkProfile)
            // Set sub (if it exists)
            const checkSubProfile = _.findWhere(checkProfile.sub_profiles, {id: parseInt(this.$route.query.sub)})
            if (this.$route.query.sub && typeof this.$route.query.sub === 'string') {
              if (checkSubProfile !== undefined) {
                await this.selectSubProfile(checkSubProfile)
                subHandleFlag = true
              }
            }
          } else {
            await this.selectProfile(checkProfile)
            subHandleFlag = true
          }
          // Set patient status
          if (subHandleFlag === true) {
            //  make sure we only set these params if sub is handled or doesn't exist
            if (this.$route.query.status && typeof this.$route.query.status === 'string') {
              //  A malformed status (mangled link, bad bookmark) falls through to the
              //  patient status picker instead of a request the API will reject
              if (this.$route.query.status === 'new' || this.$route.query.status === 'existing') {
                this.appointment.patient.status = this.$route.query.status
                this.sRegion.show = true

                // Set region
                if (this.$route.query.region && typeof this.$route.query.region === 'string') {
                  if (_.findWhere(this.regions, {id: parseInt(this.$route.query.region)})) {
                    this.appointment.region = parseInt(this.$route.query.region)
                    this.s3.show = true
                  }

                  // Get availabilities
                  this.getAvailabilities()
                }
              }
            }
          }
        }
      }

      if (this.appointment.patient.id !== null) {
        const response = await this.$http.get(`/api/patients/${this.appointment.patient.id}`)
        if (response.data.error && response.data.error.length > 0) {
          this.invalid.show = true
        } else {
          // Set needed properties
          this.completed.show = true
          this.appointment.patient.status = 'new'
          this.appointment.payment_method = response.data.payment_method
        }
      }
    },
    //  Extracts profiles that should be shown
    computed: {
      hiddenOptions: function () {
        return this.profiles.filter(function (u) {
          return !u.hidden
        })
      },
      hiddenRegions: function () {
        return this.regions.filter(function (u) {
          return !u.hidden
        })
      },
      afterHoursRegionId: function () {
        return this.regions.find(region => region.name === 'After Hours').id
      }
    },
    methods: {
      // UI Helpers
      isProfileActive (id) {
        return (typeof this.appointment.profile === 'number') && (this.appointment.profile === id)
      },
      isProfileCallToAction (profile) {
        if (typeof this.appointment.profile === 'number') {
          if (this.appointment.profile === profile.id) {
            return false
          } else {
            return (profile.is_call_to_action === true)
          }
        } else {
          return (profile.is_call_to_action === true)
        }
      },
      isSubProfileActive (id) {
        return (typeof this.appointment.sub_profile === 'number') && (this.appointment.sub_profile === id)
      },
      isNewPatientActive () {
        return !this.profileInfo.existing_only
      },
      isPatientStatusActive (status) {
        return (typeof this.appointment.patient.status === 'string') && (this.appointment.patient.status === status)
      },
      isRegionActive (id) {
        return (typeof this.appointment.region === 'number') && (this.appointment.region === id)
      },
      getPrettyDate (date) {
        const parsed = moment(date)
        return (parsed.isSame(this.getCurrentDate(), 'day')) ? 'Today' : parsed.format('ddd M/D')
      },
      getPrettyTime (time) {
        return moment(time, 'HH:mm').format('h:mma')
      },
      paddingCount (dates) {
        let maxLength = 0
        for (let date of dates) {
          maxLength = date.times.length > maxLength ? date.times.length : maxLength
        }
        return maxLength === 0 ? 5 : maxLength
      },
      isTimeSelected (office, doctor, date, time) {
        return (this.appointment.office === office) && (this.appointment.doctor === doctor) && (this.appointment.date === date) && (this.appointment.time === time)
      },
      getMaxDob () {
        return moment().subtract(this.DATE_OF_BIRTH.min, 'years').format('YYYY-MM-DD')
      },
      getMinDob () {
        return moment().subtract(this.DATE_OF_BIRTH.max, 'years').format('YYYY-MM-DD')
      },
      getCurrentDate () {
        const offset = moment().isDST() ? '-05:00' : '-06:00'
        return moment().utc().utcOffset(offset).format('YYYY-MM-DD')
      },
      showDirectLink () {
        return (this.appointment.patient.id !== null)
      },
      hideS1_1 () {
        if (this.s1_1.show === true) {
          this.s1_1.show = false
        }
      },
      showS1_1 () {
        if (this.s1_1.show === false) {
          this.s1_1.show = true
        }
      },
      hideS3 () {
        if (this.s3.show === true) {
          this.s3.show = false
        }
      },
      hideS4 () {
        if (this.s4.show === true) {
          this.s4.show = false
        }
      },

      // UI Actions
      async selectProfile (profile) {
        // Only update if there is a change
        if (this.appointment.profile !== profile.id) {
          // Fire gtag
          window.gtag('event', 'select_profile')
          this.hideS4()
          // After hours to non after hours reset
          if (this.profileInfo.after_hours === true && profile.after_hours !== true && this.appointment.patient.status !== null) {
            this.showS1_1()
            // Reset patient status
            this.s2.show = false
            // Reset region
            this.appointment.region = null
            this.sRegion.show = true
            // Hide times
            this.hideS3()
            await Vue.nextTick()
          }
          // Non after hours to after hours
          if (this.profileInfo.after_hours !== true && profile.after_hours === true && this.appointment.patient.status !== null && this.appointment.profile !== null) {
            this.showS1_1()
            // Reset patient status
            this.s2.show = false
            // Reset region
            this.appointment.region = this.after_hours_region_id
            this.sRegion.show = true
            // Hide times
            this.hideS3()
            await Vue.nextTick()
            // Skip region step if only 1 region
            this.appointment.region = this.after_hours_region_id
            // If region is virtual, don't show selector
            // This forces resync on next vue tick for selecting same time for different provider
            this.sRegion.show = true
            this.sRegion.show = false
            await Vue.nextTick()
            // Show next step and scroll to it
            this.s3.show = true
            await Vue.nextTick()
            this.$vuetify.goTo('#step-3')
            // Get availabilities
            this.getAvailabilities()
            // Hide times
            this.summaryInfo.address = null
            this.summaryInfo.doctorName = null
            this.summaryInfo.doctorUrl = null
            this.summaryInfo.city = null
            this.summaryInfo.state = null
            this.summaryInfo.zip = null
            this.summaryInfo.phone = null
            this.summaryInfo.google_place_url = null
            this.summaryInfo.map_url = null
          }
          // Set Profile
          this.appointment.profile = profile.id
          // Unset Sub Profile
          this.appointment.sub_profile = null
          // Set profile info for summary
          this.profileInfo.name = profile.name
          this.profileInfo.message = profile.message
          this.profileInfo.notes_required = profile.notes_required
          this.profileInfo.existing_only = profile.is_existing_only === true
          this.profileInfo.telemed = profile.is_telemed === true
          this.profileInfo.sub_profiles = profile.sub_profiles ? profile.sub_profiles : null
          this.profileInfo.after_hours = profile.after_hours === true
          // Unset patient status if picked profile with existing only
          if (profile.is_existing_only === true && this.appointment.patient.status === 'new') {
            this.appointment.patient.status = null
            this.sRegion.show = false
            this.appointment.region = null
            this.hideS3()
          }
          // Show next step and scroll to it
          if (profile.sub_profiles) {
            this.showS1_1()
            // Reset patient status
            this.s2.show = false
            this.appointment.patient.status = null
            // Reset region
            this.sRegion.show = false
            this.appointment.region = null
            // Hide times
            this.hideS3()
            await Vue.nextTick()
            this.$vuetify.goTo('#step-1-1')
          } else {
            this.hideS1_1()
            this.s2.show = true
            await Vue.nextTick()
            this.$vuetify.goTo('#step-2')
            // Get availabilities
            this.getAvailabilities()
          }
        }
      },
      async selectSubProfile (subProfile) {
        if (this.appointment.sub_profile !== subProfile.id) {
          // Fire gtag
          window.gtag('event', 'select_sub_profile')
          this.hideS4()
          // Set Sub Profile
          this.appointment.sub_profile = subProfile.id
          this.profileInfo.existing_only = subProfile.is_existing_only === true
          if (subProfile.is_existing_only === true && this.appointment.patient.status === 'new') {
            this.appointment.patient.status = null
            this.sRegion.show = false
            this.appointment.region = null
            this.hideS3()
          }
          // Show next step
          this.s2.show = true
          await Vue.nextTick()
          this.$vuetify.goTo('#step-2')
          // Get availabilities
          this.getAvailabilities()
        }
      },
      async selectPatientStatus (status) {
        // Only update if there is a change
        if (this.appointment.patient.status !== status) {
          // Fire gtag
          window.gtag('event', 'select_patient_status')
          this.hideS4()
          this.appointment.patient.status = status
          // Show next step and scroll to it
          this.sRegion.show = true
          if (this.regions.length === 1) {
            // Skip region step if only 1 region
            this.appointment.region = this.regions[0].id
            // If region is virtual, don't show selector
            if (this.regions[0].virtual === 1) {
              // This forces resync on next vue tick for selecting same time for different provider
              this.sRegion.show = true
              this.sRegion.show = false
            }
            // Show next step and scroll to it
            this.s3.show = true
            await Vue.nextTick()
            this.$vuetify.goTo('#step-3')
            // Get availabilities
            this.getAvailabilities()
          } else {
            if (this.profileInfo.after_hours === true) {
              // Skip region step if only 1 region
              this.appointment.region = this.after_hours_region_id
              // If region is virtual, don't show selector
              // This forces resync on next vue tick for selecting same time for different provider
              this.sRegion.show = true
              this.sRegion.show = false
              await Vue.nextTick()
              // Show next step and scroll to it
              this.s3.show = true
              await Vue.nextTick()
              this.$vuetify.goTo('#step-3')
              // Get availabilities
              this.getAvailabilities()
            } else {
              this.sRegion.show = true
              await Vue.nextTick()
              this.$vuetify.goTo('#step-region')
              // Get availabilities
              this.getAvailabilities()
            }
          }
        }
      },
      async selectRegion (region) {
        // Only update if there is a change
        if (this.appointment.region !== region) {
          // Fire gtag
          window.gtag('event', 'select_region')
          this.hideS4()
          this.appointment.region = region
          // Show next step and scroll to it
          this.s3.show = true
          await Vue.nextTick()
          this.$vuetify.goTo('#step-3')
          // Get availabilities
          this.getAvailabilities()
        }
      },
      async selectTime (entity, date, time) {
        // Fire gtag
        window.gtag('event', 'select_time')
        // Set appointment info
        this.appointment.office = entity.office_id
        this.appointment.date = date
        this.appointment.time = time
        this.appointment.doctor = entity.doctor_id
        // Set office info for summary
        this.summaryInfo.address = entity.address
        this.summaryInfo.doctorName = entity.name
        this.summaryInfo.doctorUrl = entity.doctor_url
        this.summaryInfo.city = entity.city
        this.summaryInfo.state = entity.state
        this.summaryInfo.zip = entity.zip
        this.summaryInfo.phone = entity.phone
        this.summaryInfo.google_place_url = entity.google_place_url
        this.summaryInfo.map_url = entity.map_url
        // Show next step and scroll to it
        this.s4.show = true
        await Vue.nextTick()
        this.$vuetify.goTo('#step-4')
      },
      async getNext () {
        // Fire gtag
        window.gtag('event', 'select_next_page')
        this.hideS4()
        // Push next date to previous
        this.s3.previous.push(this.s3.current)
        this.s3.current = this.s3.next
        this.s3.next = null
        // Get availabilities
        await this.getAvailabilities()
      },
      async getPrevious () {
        // Fire gtag
        window.gtag('event', 'select_previous_page')
        this.hideS4()
        // Pop most recently added
        this.s3.current = this.s3.previous.pop()
        // Get availabilities
        await this.getAvailabilities()
      },
      parseDate: function (date) {
        if (!date) {
          return null
        }
        const tmpDate = moment(date, ['MM/DD/YYYY', 'M/D/YYYY'], true)
        if (tmpDate.isValid() === true) {
          return tmpDate.format('YYYY-MM-DD')
        } else {
          return null
        }
      },
      formatDate: function (date) {
        if (!date) {
          return null
        }
        const tmpDate = moment(date)
        if (tmpDate.isValid()) {
          return moment(date).format('MM/DD/YYYY')
        } else {
          return date
        }
      },
      saveDob (date) {
        this.dateOfBirthFormatted = this.formatDate(date)
        this.$refs.dobMenu.save(this.dateOfBirthFormatted)
      },
      showError (message) {
        this.errorSnackbar.message = message
        this.errorSnackbar.visible = true
      },

      // Logic
      setDateCount () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            this.s3.dateCount = 3
            break
          case 'sm':
            this.s3.dateCount = 3
            break
          case 'md':
            this.s3.dateCount = 5
            break
          case 'lg':
            this.s3.dateCount = 7
            break
          case 'xl':
            this.s3.dateCount = 7
            break
        }
      },
      async getAvailabilities () {
        // Only get if step three is visible
        if (this.s3.show === true) {
          try {
            // Clear previously selected time
            this.appointment.date = null
            this.appointment.time = null
            // Get availabilities
            this.s3.error = false
            this.s3.loading = true

            // Stayed on page once the day changed (and timezone correction)
            if (moment(this.s3.current).isBefore(this.getCurrentDate(), 'day')) {
              this.s3.current = this.getCurrentDate()
              this.s3.previous.length = 0
              this.s3.next = null
            }

            const response = await this.$http.get('/api/availabilities', {
              params: {
                start_date: this.s3.current,
                date_count: this.s3.dateCount,
                profile: this.appointment.profile,
                sub_profile: this.appointment.sub_profile,
                status: this.appointment.patient.status,
                region: this.appointment.region,
                latitude: this.appointment.latitude,
                longitude: this.appointment.longitude
              }
            })

            this.s3.entities = response.data.entities
            this.s3.next = response.data.next_date
            this.s3.loading = false
            await Vue.nextTick()
            this.$vuetify.goTo('#step-3')
            return true
          } catch (e) {
            this.s3.loading = false
            this.s3.error = true
            return false
          }
        }
      },
      async bookAppointment () {
        try {
          // Validate form
          const isValid = await this.$validator.validateAll()
          if (isValid === true) {
            // Fire Facebook Schedule event
            window.fbq('track', 'Schedule')
            // Fire gtag
            window.gtag('event', 'booked')
            // Fire TikTok
            window.ttq.track('PlaceAnOrder')
            // Book appointment
            this.s4.booking = true

            // Set after hours flag if office is after_hours
            if (this.appointment.office === 567) {
              this.appointment.after_hours = true
            }

            const response = await this.$http.post('/api/appointments', this.appointment)
            this.appointment.job_id = response.data.data.id
            this.s4.booking = false
            // Hide all previous steps
            this.media.show = false
            this.s1.show = false
            this.s1_1.show = false
            this.s2.show = false
            this.sRegion.show = false
            this.s3.show = false
            this.s4.show = false
            // Show completed step
            this.completed.show = true
            await Vue.nextTick()
            this.$vuetify.goTo('#completed')
          } else {
            let fields = []
            for (let error of this.errors) {
              fields.push(error.field)
            }
            this.showError('Please correct errors in: ' + fields.join(', '))
          }
        } catch (e) {
          this.s4.booking = false
          if (typeof e.response === 'object' && typeof e.response.data === 'object' && e.response.data.message === 'time-not-available') {
            this.showError('The appointment time you selected is no longer available. Please select a different time.')
            await this.getAvailabilities()
            this.hideS4()
          } else {
            this.showError('Something went wrong')
          }
        }
      },
      async startYourVisit () {
        try {
          // Validate form
          const isValid = await this.$validator.validateAll()
          if (isValid === true) {
            // Fire Facebook Schedule event
            window.fbq('track', 'Schedule')
            // Fire gtag
            window.gtag('event', 'booked')
            // Fire TikTok
            window.ttq.track('PlaceAnOrder')
            // Book appointment
            this.appointment.time = moment().format('HH:mm')
            this.appointment.date = moment().format('YYYY-MM-DD')
            this.appointment.after_hours = true
            this.s4.booking = true
            const response = await this.$http.post('/api/appointments', this.appointment)
            this.appointment.job_id = response.data.data.id
            this.s4.booking = false
            // Hide all previous steps
            this.media.show = false
            this.s1.show = false
            this.s1_1.show = false
            this.s2.show = false
            this.sRegion.show = false
            this.s3.show = false
            this.s4.show = false
            // Redirect patient to after hours url only if successful to this point
            window.location.replace(this.profileInfo.after_hours_url)
          } else {
            let fields = []
            for (let error of this.errors) {
              fields.push(error.field)
            }
            this.showError('Please correct errors in: ' + fields.join(', '))
          }
        } catch (e) {
          this.s4.booking = false
          if (typeof e.response === 'object' && typeof e.response.data === 'object' && e.response.data.message === 'time-not-available') {
            this.showError('The appointment time you selected is no longer available. Please select a different time.')
            await this.getAvailabilities()
            this.hideS4()
          } else {
            this.showError('Something went wrong')
          }
        }
      }
    }
  }
</script>

<style scoped>
  .step-media {
    margin: auto;
  }

  .select-button {
    width: 230px;
    height: 50px;
  }

  .yellow {
    background-color: #f7ff16 !important;
    border-color: #f7ff16 !important;
  }

  .book-button {
    color: #fff;
    background-color: #4caf50 !important;
    width: 250px;
    height: 50px;
  }

  .date-column {
    min-width: 69px;
    margin: 0 2px;
  }

  .text-underline {
    text-decoration: underline;
  }

  .time-outer {
    margin: 3px 0;
  }

  .clickable {
    cursor: pointer;
  }

  .time-item {
    color: #fff;
    align-items: center;
    border-radius: 2px;
    display: block;
    flex: 0 0 auto;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    margin: 0;
    padding: 0 3px;
    outline: 0;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    position: relative;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    will-change: box-shadow;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  }

  .time-item-selected {
    color: #fff;
    align-items: center;
    border-radius: 2px;
    display: block;
    flex: 0 0 auto;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    margin: 0;
    padding: 0 3px;
    outline: 0;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
    position: relative;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    will-change: box-shadow;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  }

  .time-item-padding {
    background-color: #f5f5f5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue